import router from './router'
import store from './store'
import { Loading } from 'element-ui'
import { getToken } from '@/utils/auth' // get token from cookie

import { route404 } from '@/router'
import { isInjectToGeoTab } from './utils'

const whiteList = ['/login', '/forgot_password'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
    // console.log('Permission', to, from)
    // set page title
    document.title = to.meta.pageTitle || 'Treker Tenant Portal'

    const isInjectGeoTab = isInjectToGeoTab()

    if (to.path === '/geotab') {
        next()
    } else {

        if(to.path !== from.path) {
            store.commit('router/SET_FROM', from)
            store.commit('router/SET_TO', to)
        }

        // determine whether the user has logged in
        const hasToken = getToken()

        if (hasToken) {
            if (to.path === '/login') {
                // if is logged in, redirect to the home page
                next({ path: '/' })
            } else {
                if(store.state.account.navigations.length > 0) {
                    next()
                }else {
                    const loading = Loading.service()
                    try {
                        await Promise.all([store.dispatch('account/getUserInfo'), store.dispatch('settings/getSettings')])
                        // await store.dispatch('account/getUserInfo')
                        loading.close()

                        const accessRouters = await store.dispatch('account/generateRoutes')

                        // dynamically add accessible routes
                        accessRouters.forEach(el => {
                            router.addRoute('home', el)
                        })
                        router.addRoute(route404)
                        next({...to, replace: true})
                    } catch {
                        await store.dispatch('account/resetToken')
                        loading.close()

                        if (isInjectGeoTab) {
                            window.parent.postMessage({ cmd: 'Expired' }, '*')
                            next()
                        } else {
                            if(to.fullPath && to.path !== '/force_reset_password') {
                                next(`/login?redirect=${to.fullPath}`)
                            }else {
                                next('/login')
                            }
                        }
                    }
                }
            }
        } else {
            /* has no token*/
            if (isInjectGeoTab) {
                window.parent.postMessage({ cmd: 'Expired' }, '*')
                next()
            } else {
                if (whiteList.indexOf(to.path) !== -1) {
                    next()
                } else {
                    // other pages that do not have permission to access are redirected to the login page.
                    if(to.fullPath && to.path !== '/force_reset_password' && to.path !== '/geotab') {
                        next(`/login?redirect=${to.fullPath}`)
                    }else {
                        next('/login')
                    }
                }
            }
        }

    }
})

router.afterEach(() => {
})